import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";

const GetSchool = async (SchoolName) => {
  if (SchoolName) {
    try {
      const SchoolCollection = await collection(db, "Schools");
      const q = query(
        SchoolCollection,
        where("IsDeleted", "==", false),
        where("SchoolName", "==", SchoolName.trim().toLowerCase())
      );

      const SchoolsSnapshot = await getDocs(q);
      console.log(
        "SchoolName: ",
        SchoolName,
        " SchoolsSnapshot:",
        SchoolsSnapshot
      );

      let SchoolsData = [];

      SchoolsSnapshot.forEach((doc) => {
        SchoolsData.push({ ...doc.data(), id: doc.id });
      });
      console.log("SchoolsData Length: ", SchoolsData.length);
      return SchoolsData;
    } catch (error) {
      console.log(error);
    }
  }
};

export default GetSchool;
